import { render } from "./checkfeatures.vue?vue&type=template&id=b12a68ec"
import script from "./checkfeatures.vue?vue&type=script&lang=js"
export * from "./checkfeatures.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__